const initialState = { isLoading: false, data: null };
const getProfilePending = (state) => ({
  ...state,
  isLoading: true,
});
const getProfileFullfilled = (state, payload) => ({
  ...state,
  isLoading: false,
  data: payload?.payload?.data?.data,
});
const getProfileRejected = (state) => ({
  ...state,
  isLoading: false,
  data: null,
});

// update user profile

const updateProfilePending = (state) => ({
  ...state,
  isLoading: true,
});
const updateProfileFullfilled = (state, payload) => ({
  ...state,
  isLoading: false,
  data: payload?.payload?.data?.data,
});
const updateProfileRejected = (state) => ({
  ...state,
  isLoading: false,
  data: null,
});

export default function (state = initialState, action) {
  switch (action.type) {
    case 'GET_PROFILE_PENDING':
      return getProfilePending(state, action);

    case 'GET_PROFILE_FULFILLED':
      return getProfileFullfilled(state, action);

    case 'GET_PROFILE_REJECTED':
      return getProfileRejected(state, action);

    case 'UPDATE_PROFILE_PENDING':
      return updateProfilePending(state, action);

    case 'UPDATE_PROFILE_FULFILLED':
      return updateProfileFullfilled(state, action);

    case 'UPDATE_PROFILE_REJECTED':
      return updateProfileRejected(state, action);

    default:
      return {
        ...state,
      };
  }
}
